import { Injectable } from "@angular/core";

import { BaseHandlerErrorMapper } from "@app/core/shared/data/network/base-handler-error.mapper";
import { Observable, catchError, map, timeout } from "rxjs";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { HandlerParameters } from "@app/core/shared/data/network/base-handler.parameters";
import { VERSION } from "src/autogenerated-version";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { RoutesSlugs } from "@app/routes-slugs";

@Injectable()
export class BaseHandler {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.errorHandler = BaseHandlerErrorMapper.handleError;
  }

  errorHandler = BaseHandlerErrorMapper.handleError;

  execute(parameters: HandlerParameters): Observable<any> {
    // Add the language code to the header.
    const browserLanguage = this.translateService.getBrowserLang();
    parameters.header["Language-Code"] =
      this.translateService.currentLang || browserLanguage || "";
    parameters.header["App-Version"] = VERSION;

    const requestOptions = {
      body: parameters.body,
      headers: parameters.header,
      params: parameters.urlParams,
      responseType: parameters.responseType,
    };
    const httpRequest = this.http
      .request(parameters.method, parameters.url, requestOptions);

    return environment.NAME === "PROD"
      ? httpRequest.pipe(
          timeout(5000),
          catchError((errorResponse) =>
            this.handleHttpError(errorResponse as HttpErrorResponse)
          )
        )
      : httpRequest.pipe(
          catchError((errorResponse) =>
            this.handleHttpError(errorResponse as HttpErrorResponse)
          )
        );
  }

  private handleHttpError(
    errorResponse: HttpErrorResponse
  ): Observable<never> | Observable<false> {
    if (errorResponse.status === 0) {
      this.navigateToNoInternet();
    }

    return this.errorHandler(errorResponse);
  }

  private navigateToNoInternet(): void {
    const targetUrl = `/${RoutesSlugs.NO_INTERNET}`;
    if (this.router.url.startsWith(targetUrl)) {
      return;
    }

    this.router.navigate([targetUrl], {
      queryParams: { returnUrl: this.router.url },
    });
  }
}
